import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const competitions = [
  {
    id: 1,
    title: 'IASAS Singapore 2025',
    subtitle: 'International Athletic & Activities Conference',
    location: 'Singapore',
    date: 'March 2025',
    description: 'Represented ISM at the prestigious IASAS badminton tournament, competing against top international schools across Southeast Asia. Demonstrated exceptional teamwork and competitive spirit.',
    image: `${DATA_BASE_URL}/data/badminton/photos/IASAS SINGAPORE 25 BADMINTON TEAM ISM.jpg`,
    badge: 'International',
    badgeColor: 'var(--color-accent-6)',
  },
  {
    id: 2,
    title: 'IASAS Malaysia 2024',
    subtitle: 'International Athletic & Activities Conference',
    location: 'Malaysia',
    date: 'April 2024',
    description: 'Represented ISM at the prestigious IASAS badminton tournament, competing against top international schools across Southeast Asia. Demonstrated exceptional teamwork and competitive spirit.',
    image: `${DATA_BASE_URL}/data/badminton/photos/BADMINTON MALAYSIA 24.jpg`,
    badge: 'International',
    badgeColor: 'var(--color-accent-6)',
  },
  {
    id: 3,
    title: 'Thailand Tournament 2025',
    subtitle: 'International Badminton pre-IASAS',
    location: 'Thailand',
    date: 'March 2025',
    description: 'Competed in a pre-IASAS international tournament showcasing advanced badminton techniques and strategic gameplay. Gained valuable competitive experience against diverse opponents.',
    image: `${DATA_BASE_URL}/data/badminton/photos/PRE-IASAS BANGKOK MARCH 2025 .JPG`,
    badge: 'International',
    badgeColor: 'var(--color-accent-5)',
  },
  {
    id: 4,
    title: 'Varsity Season 2025',
    subtitle: 'ISM Badminton Team',
    location: 'Manila, Philippines',
    date: '2024-2025',
    description: 'Active member of ISM varsity badminton team. Regular training sessions focused on improving technique, stamina, and match strategies. Contributing to team cohesion and success.',
    image: `${DATA_BASE_URL}/data/badminton/photos/VARISTY BADMINTON.jpeg`,
    badge: 'Varsity',
    badgeColor: 'var(--color-accent-7)',
  },
];

const CompetitionHighlightsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Competition Highlights
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Major tournaments and competitions representing ISM in badminton
          </p>
        </div>

        {/* Competitions Grid */}
        <div className="space-y-10 sm:space-y-12">
          {competitions.map((competition, index) => (
            <div
              key={competition.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <ImageCard
                  src={competition.image}
                  alt={competition.title}
                  aspectRatio="aspect-video"
                  className="hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className={`space-y-4 sm:space-y-6 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                {/* Badge */}
                <div className="inline-block">
                  <span
                    className="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold"
                    style={{
                      backgroundColor: competition.badgeColor,
                      color: 'white',
                    }}
                  >
                    {competition.badge}
                  </span>
                </div>

                {/* Title and subtitle */}
                <div className="space-y-2">
                  <h3
                    className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {competition.title}
                  </h3>
                  <p
                    className="text-lg sm:text-xl font-semibold"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    {competition.subtitle}
                  </p>
                </div>

                {/* Location and Date */}
                <div className="flex flex-wrap gap-3 sm:gap-4 text-xs sm:text-sm">
                  <div
                    className="flex items-center gap-1.5 sm:gap-2"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{competition.location}</span>
                  </div>
                  <div
                    className="flex items-center gap-1.5 sm:gap-2"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{competition.date}</span>
                  </div>
                </div>

                {/* Description */}
                <p
                  className="text-sm sm:text-base md:text-lg leading-relaxed"
                  style={{ color: 'var(--color-subtle)' }}
                >
                  {competition.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompetitionHighlightsSection;
